import {GenericService} from '@/shared/xhttp';
import {Redirect, User} from '@/models';

export class RedirectService extends GenericService<Redirect> {
	public postCheckTokenResetPassword(user: User, queryString: string): Promise<Redirect> {
		return this.post(`/check-token-reset-password/${user.email}${queryString}`);
	}
}